export default {
  'proTech.proEquip': '生产设备',
  'proTech.chiselIntroduce': '钎杆介绍',
  'proTech.testingInstrument': '测试仪器',
  'proTech.techProcess': '工艺流程'
}
